<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex";
import Pagination from "../../../components/pagination.vue";
export default {
    page: {
        title: "Seasons",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Pagination
    },
    data() {
        return {
            title: "Seasons",
            totalWingband: 0,
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            statistics_data: {
                early_bird: "",
                local: "",
                national: "",
                late_born: "",
            },
            filter: {
                year: "",
                chapter: "",
                wingbanding_team: "",
                farms: "",
                season: 1,
            },
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
    },
    methods: {
        ...mapActions("wingband", {
            getWList: "getList",
        }),
        ...mapActions("seasons", {
            getList: "getList",
            getStatistics: "getStatistics",
        }),
        filterList() {
            this.initList(1);
            this.initStatistics(1);
        },
        async initList(p) {
            var pl = {
                page: p,
                limit: 10,
                sort: "created_at",
                encoder: this.$route.query.id,
            };
            if (this.filter.year) {
                pl["year"] = this.filter.year;
            }
            if (this.filter.chapter) {
                pl["chapter"] = this.filter.chapter;
            }
            if (this.filter.wingbanding_team) {
                pl["wingbanding_team"] = this.filter.wingbanding_team;
            }
            if (this.filter.farms) {
                pl["farms"] = this.filter.farms;
            }
            if (this.filter.season) {
                pl["season"] = this.filter.season;
            }
            this.loading = true;
            const data = await this.getWList(pl);
            this.loading = false;
            this.data.list = data.data;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;

            if (data.data == null || data.data == "") {
                this.data.list = []
            }
        },
        async initStatistics() {
            this.loading = true;
            var pl = {
                encoder: this.$route.query.id
            }
            if (this.filter.year) {
                pl["year"] = this.filter.year;
            }
            const data = await this.getStatistics(pl);

            this.loading = false;
            this.statistics_data.early_bird = data.data[0].entry;
            this.statistics_data.local = data.data[1].entry;
            this.statistics_data.national = data.data[2].entry;
            this.statistics_data.late_born = data.data[3].entry;
        },
    },
    mounted() {
        this.initList(1);
        this.initStatistics();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-2 p-2">
                    <div class="grid-4">
                        <div class="season-card-violet w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ statistics_data.early_bird ? statistics_data.early_bird : 0 }}
                                </h1>
                                <h5 class="text-white">Early Bird</h5>
                            </div>
                        </div>
                        <div class="season-card-green w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ statistics_data.local ? statistics_data.local : 0 }}</h1>
                                <h5 class="text-white">Local</h5>
                            </div>
                        </div>
                        <div class="season-card-yellow w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ statistics_data.national ? statistics_data.national : 0 }}
                                </h1>
                                <h5 class="text-white">National</h5>
                            </div>
                        </div>
                        <div class="season-card-silver w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ statistics_data.late_born ? statistics_data.late_born : 0 }}
                                </h1>
                                <h5 class="text-white">Lateborn</h5>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                
                <div class="card mb-2 p-3">
                    <div class="col-md-12 d-flex">
                        <div class="col-10">
                            <div class="grid-2">
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Year</label>
                                    <input type="text" class="form-control" v-model="filter.year">
                                </div>
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Search</label>
                                    <input type="text" class="form-control" v-model="filter.search">
                                </div>
                            </div>
                            <!-- <div class="grid-2">
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Wingbanding Team</label>
                                    <select class="form-control text-center" v-model="filter.wingbanding_team">
                                        <option value="0" hidden selected disabled>-- Select Wingbanding Team --
                                        </option>
                                        <option value="1">All</option>
                                    </select>
                                </div>
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Farms</label>
                                    <select class="form-control text-center" v-model="filter.farms">
                                        <option value="0" hidden selected disabled>-- Select Farms --</option>
                                        <option value="1">All</option>
                                    </select>
                                </div>
                            </div> -->
                        </div>
                        <div class="col-2">
                            <div class="d-flex justify-content-center align-items-center custom-border">
                                <button class="btn btn-success py-4 px-5" @click="filterList()">Apply Filter</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="card mb-2 p-0 pt-2">
                    <div class="season d-flex mt-1 ms-1">
                        <h6 @click="filter.season = 1, filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.season == 1 ? 'bg-white text-color-tabs border border-bottom-0' : 'bg-light'">
                            Early Bird</h6>
                        <h6 @click="filter.season = 2, filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.season == 2 ? 'bg-white text-color-tabs border border-bottom-0' : 'bg-light'">
                            Local</h6>
                        <h6 @click="filter.season = 3, filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.season == 3 ? 'bg-white text-color-tabs border border-bottom-0' : 'bg-light'">
                            National</h6>
                        <h6 @click="filter.season = 4, filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.season == 4 ? 'bg-white text-color-tabs border border-bottom-0' : 'bg-light'">
                            Lateborn</h6>
                        <h6 @click="filter.season = 5, filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.season == 5 ? 'bg-white text-color-tabs border border-bottom-0' : 'bg-light'">
                            Genesis</h6>
                    </div>
                    <div class="pt-3 custom-overflow">
                        <table class="mb-0 table">
                            <thead>
                                <tr class="bg-light">
                                    <th>Stag Registry No.</th>
                                    <th>Name of Breeders</th>
                                    <th>Farm Name</th>
                                    <th>Farm Address</th>
                                    <th>Province</th>
                                    <th>Chapter</th>
                                    <th>Contact No.</th>
                                    <th>Wingband No.</th>
                                    <th>Feather Color</th>
                                    <th>Leg Color</th>
                                    <th>Comb Shape</th>
                                    <th>Nose Markings</th>
                                    <th>Feet Markings</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in this.data.list" :key="index">
                                    <td>
                                        {{ index + 1 }}
                                    </td>
                                    <td>
                                        {{ row.breeder_name }}
                                    </td>
                                    <td>
                                        {{ row.farm_name }}
                                    </td>
                                    <td>
                                        {{ row.farm_address }}
                                    </td>
                                    <td>
                                        {{ row.province }}
                                    </td>
                                    <td>
                                        {{ row.chapter }}
                                    </td>
                                    <td>
                                        {{ row.contact_number }}
                                    </td>
                                    <td>
                                        {{ row.wingband_number }}
                                    </td>
                                    <td>
                                        {{ row.feather_color }}
                                    </td>
                                    <td>
                                        {{ row.leg_color }}
                                    </td>
                                    <td>
                                        {{ row.comb_shape }}
                                    </td>
                                    <td>
                                        {{ row.nose_markings }}
                                    </td>
                                    <td>
                                        {{ row.feet_markings }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="no-data disflex" v-if="this.data.list == null || this.data.list == ''">No wingbands
                            found...
                        </div>
                    </div>
                    <Pagination :data="data" @emitPage="initList" class="me-2" />
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: center !important;
}

.table> :not(caption)>*>* {
    text-align: center !important;
    padding: .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}

.season-card-violet  { background-color: #6f42c1; }
.season-card-green   { background-color: #34c38f; }
.season-card-yellow  { background-color: #f1b44c; }
.season-card-silver  { background-color: #adb5bd; }
.season-card-skyblue { background-color: #0dcaf0; }
</style>